import { render, staticRenderFns } from "./living-expenses-payer-select.vue?vue&type=template&id=2cc2860c&"
import script from "./living-expenses-payer-select.vue?vue&type=script&lang=js&"
export * from "./living-expenses-payer-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
